// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"styles_boardContainer__SczdP","redesignAffiliateContainer":"styles_redesignAffiliateContainer__BWn1H system_captionL__E1FNu"};